import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const mediaUrl = (path) => (!path ? null : (/^https?:\/\//.test(path) ? path : `${API}/files/${path}`));
